import React from 'react';
import './MealPlanCards.css';

const MealPlanCards = ({ plans = [], getSubtitle, renderCta }) => {
  return (
    <>
      {plans.map((plan, index) => (
        <div
          key={plan.id ?? index}
          className={`mpc-card${plan.featured ? ' mpc-card--featured' : ''}`}
        >
          {plan.tag && <span className="mpc-card__badge">{plan.tag}</span>}
          <div className="mpc-card__img">
            <img src={plan.image} alt={plan.name} />
          </div>
          <div className="mpc-card__body">
            <h3>{plan.name}</h3>
            {getSubtitle && <p className="mpc-card__subtitle">{getSubtitle(plan)}</p>}
            <ul className="mpc-card__features">
              {plan.features.map((feature, featureIndex) => (
                <li key={featureIndex}>✓ {feature}</li>
              ))}
            </ul>
            {plan.savings && <p className="mpc-card__savings">{plan.savings}</p>}
            {renderCta ? <div className="mpc-card__cta">{renderCta(plan)}</div> : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default MealPlanCards;
